import { searchAssets, useUserContext } from "@dexteel/mesf-core";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTaskListContext } from "../context/taskListContext";

export const useInitializeTaskList = () => {
  const {
    state: { defaultAreaId },
  } = useUserContext();

  const { data: allAssets } = searchAssets();

  const navigate = useNavigate();
  const [filtersLoaded, setFiltersLoaded] = useState(false);

  const { state, actions } = useTaskListContext();

  const params = useParams();

  useEffect(() => {
    if (allAssets && allAssets.length) {
      setFiltersLoaded(true);
    }
  }, [allAssets]);

  useEffect(() => {
    if (filtersLoaded) {
      if (params.AssetIdParam) {
        actions.setAssetSearchId(params.AssetIdParam);
        actions.setAssetSearchName(
          state.allAssets.find(
            (asset) => asset.AssetId === Number.parseInt(params.AssetIdParam!)
          )?.AssetName || "Unknown"
        );
      }
    }
  }, [JSON.stringify(params), filtersLoaded, allAssets]);
};
